import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/useAuthStore';

const Pricing = () => {
    const navigate = useNavigate();
    const { loginAsGuest } = useAuthStore();

    const containerVariants = { hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.2 } } };
    const cardVariants = { hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } } };

    return (
        <div style={{ flex: 1, padding: '80px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto 60px' }}>
                <motion.h2 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} style={{ margin: 0, fontSize: '36px', fontWeight: '800', color: '#0f172a' }}>
                    Simple, transparent pricing
                </motion.h2>
                <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} style={{ margin: '15px 0 0 0', color: '#64748b', fontSize: '18px', lineHeight: '1.6' }}>
                    No hidden fees. No surprise charges. Choose the plan that best fits your business needs.
                </motion.p>
            </div>

            <motion.div variants={containerVariants} initial="hidden" animate="show" style={{ width: '100%', maxWidth: '1000px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>

                {/* 1. الكارت المجاني (Guest Mode) */}
                <motion.div variants={cardVariants} whileHover={{ y: -10 }} className="glass-card" style={{ padding: '40px', backgroundColor: 'white', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                    <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#0f172a' }}>Starter</h3>
                    <p style={{ margin: '10px 0 20px', color: '#64748b', fontSize: '14px' }}>Perfect for freelancers.</p>
                    <div style={{ margin: '0 0 30px', color: '#0f172a' }}>
                        <span style={{ fontSize: '40px', fontWeight: '800' }}>$0</span>
                        <span style={{ color: '#64748b', fontWeight: '500' }}>/month</span>
                    </div>
                    <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 30px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        {['Up to 5 Clients', 'Create Basic Invoices', 'Email Support'].map((feature, i) => (
                            <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#334155', fontSize: '15px', fontWeight: '500' }}>
                                <Check size={18} color="#10b981" /> {feature}
                            </li>
                        ))}
                    </ul>
                    {/* 👇 زرار الكارت المجاني يوجه للداشبورد مباشرة */}
                    <button
                        onClick={() => {
                            loginAsGuest(); // بنفهمه إنه زائر الأول
                            navigate('/dashboard'); // وبعدين نوديه الداشبورد
                        }}
                        style={{ width: '100%', padding: '12px', backgroundColor: '#f1f5f9', color: '#0f172a', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}
                    >
                        Get Started (Free)
                    </button>
                </motion.div>

                {/* 2. كارت الـ Pro (Trial Mode) */}
                <motion.div variants={cardVariants} whileHover={{ y: -10 }} style={{ padding: '40px', backgroundColor: '#0f172a', borderRadius: '16px', border: '1px solid #1e293b', position: 'relative', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2)' }}>
                    <div style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', backgroundColor: '#3b82f6', color: 'white', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '700', letterSpacing: '1px' }}>MOST POPULAR</div>
                    <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: 'white' }}>Professional</h3>
                    <p style={{ margin: '10px 0 20px', color: '#94a3b8', fontSize: '14px' }}>For growing agencies.</p>
                    <div style={{ margin: '0 0 30px', color: 'white' }}>
                        <span style={{ fontSize: '40px', fontWeight: '800' }}>$29</span>
                        <span style={{ color: '#94a3b8', fontWeight: '500' }}>/month</span>
                    </div>
                    <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 30px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        {['Unlimited Clients', 'Advanced PDF Invoices', 'Financial Dashboard', 'Priority Support'].map((feature, i) => (
                            <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#e2e8f0', fontSize: '15px', fontWeight: '500' }}>
                                <Check size={18} color="#3b82f6" /> {feature}
                            </li>
                        ))}
                    </ul>
                    {/* 👇 زرار الـ Pro يوجه لصفحة التسجيل للـ 14 يوم */}
                    <button onClick={() => navigate('/register')} style={{ width: '100%', padding: '12px', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>
                        Start 14-Day Free Trial
                    </button>
                </motion.div>

            </motion.div>
        </div>
    );
};

export default Pricing;